import React from 'react'
import PropTypes from 'prop-types'
import { Link, generatePath } from 'react-router-dom'
import cn from 'classnames'
import { ROUTES } from '../../../routes'
import TCStatusBadge from '../../t&c-status-badge'
import styles from './index.module.scss'

function getAccountTcDisplayStatus (account) {
  const current = account?.currentClientTermsAndCondition || null

  return current?.displayStatus || null
}

export default function TicketAccountContainer ({ account }) {
  const tcStatus = getAccountTcDisplayStatus(account)
  return (
    <div className='dis-list-group'>
      <div className='dis-list-item dis-list-item-gray'>
        <div className='dis-list-group-header'>
          <h5>Account Details</h5>
          <Link className='dis-list-group-header-link' to={generatePath(ROUTES.client, { clientId: account.id })}>Go To Account</Link>
        </div>
      </div>
      <div className='dis-list-item'>
        <div className={cn('dis-list-item-header', styles.tcStatusRow)}>
          Account Name
          <TCStatusBadge status={tcStatus} />
        </div>
        <div className={cn('dis-list-item-text', styles.tcStatusRow)}>
          {account.name}
        </div>
      </div>
    </div>
  )
}

TicketAccountContainer.propTypes = {
  account: PropTypes.object.isRequired
}
